import React from 'react';
import PropTypes from 'prop-types';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import FormikField from './FormikField';

const FormikDatePickerField = ({ field, form, dateFormat, mask, required, ...other }) => (
  <FormikField field={field} form={form}>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        inputVariant="outlined"
        format={dateFormat}
        mask={mask}
        placeholder="DD/MM/YYYY"
        autoOk
        invalidDateMessage=""
        minDateMessage=""
        maxDateMessage=""
        required={required}
        onChange={(date, value) => {
          if (value === mask && !required) {
            form.setFieldValue(field.name, null, true);
          } else {
            form.setFieldValue(field.name, date, true);
          }
        }}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        {...other}
      />
    </MuiPickersUtilsProvider>
  </FormikField>
);

FormikDatePickerField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
    setTouched: PropTypes.func,
  }).isRequired,
  dateFormat: PropTypes.string,
  mask: PropTypes.string,
  required: PropTypes.bool,
  other: PropTypes.object,
};

FormikDatePickerField.defaultProps = {
  dateFormat: 'dd/MM/yyyy',
  mask: '__/__/____',
  required: false,
  other: null,
};

export default FormikDatePickerField;
